import type { MapboxOptions } from 'mapbox-gl';
import { GEOGRAPHIC_AT_BBOX } from '../geographic-values';

export const AT_DEFAULT_MAP_OPTIONS: MapboxOptions = {
  container: 'map-container',
  style: 'mapbox://styles/mapbox/streets-v12',
  bounds: GEOGRAPHIC_AT_BBOX,
  preserveDrawingBuffer: true,
  cooperativeGestures: true,
  locale: {
    'ScrollZoomBlocker.CtrlMessage':
      'Nutzen Sie ctrl + scroll, um in der Karte zu zoomen',
    'ScrollZoomBlocker.CmdMessage':
      'Nutzen Sie ⌘ + scroll, um in der Karte zu zoomen',
    'TouchPanBlocker.Message': 'Nutzen Sie 2 Finger, um in der Karte zu zoomen',
  },
};
